import { type IMortgageBannerPikContractSchema } from '../repositories/special-promos/entities/mortgage_banner_pik_contract/MortgageBannerPikContractSchema';
import { type IMortgageBanner } from '../types/mortgageBanner';

export function prepareMortgageBanner(response: IMortgageBannerPikContractSchema): IMortgageBanner {
  return {
    disclaimer: response.disclaimer,
    hitUrl: response.hitUrl,
    image: response.image,
  };
}
